// extracted by mini-css-extract-plugin
export default {"heading":"FlooringColorsMenu_heading__CobKm","FlooringColorsMenu":"FlooringColorsMenu_FlooringColorsMenu__4xqUU"};